import { useEffect, useState } from "react";
import Trash from "src/components/ui-icons/buttons/Trash";
import { useAppSelector } from "src/hooks/redux";
import { deleteItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import CustomRadio from "src/pages/DashboardPage/acadia/components/Tests/components/Ui/CustomRadio";
import { SelectedCurrentUser } from "src/modules/users/types";
import { selectCurrentUser } from "src/modules/users/selector";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import Loading from "src/components/Loading";
import { favoriteFiltersListName } from "src/api/config";

export const FavoriteFiltersList = ({ reRenderTableFlag, reRenderFilterSettings, setReRenderFilterSettings, setFiltersParams, type, setCurrentTypeInc, filtersParams, listQuestions, setDefaultUserFilter, setUserFilterCheck, userFilterCheck, setReRenderUserFilter }: any) => {

    const [favoriteFilters, setFavoriteFilters] = useState<any>([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const currentUser: SelectedCurrentUser = useAppSelector(selectCurrentUser);
    const [checkedFilter, setCheckedFilter] = useState<any>({});
    const [fieldsFilter, setFieldsFilter] = useState<any>([
        {
            key: "Status",
            title: "Статус",
        },
        {
            key: "Collection",
            title: "Коллекция",
        },
        {
            key: "Department",
            title: "Подразделения/Функция",
        },
        {
            key: "Sector",
            title: "Колонна/Направление/Отдел",
        },
        {
            key: "Process",
            title: "Блок колонны/Участок",
        },
        {
            key: "DocType",
            title: "Тип документа",
        },
        {
            title: "Рабочее место",
            key: "WorkPlaces",
        },
        {
            key: "Lines",
            title: "Линия розлива",
        },
        {
            key: "Critical",
            title: "Критичность",
        },
        {
            title: "Название оборудования",
            key: "Equipments_Title",
        },
        {
            title: "Производитель оборудования",
            key: "Equipments_Manufacturer",
        },
        {
            title: "Модель оборудования",
            key: "Equipments_Model",
        },
        {
            title: "Тип оборудования",
            key: "Equipments_TypeEquipment",
        },
        {
            title: "SAP № технического места",
            key: "Equipments_SAP",
        },
        {
            key: "ResponsibleForRevisionEmail",
            title: "Ответственный за пересмотр",
        },
        {
            key: "AuthorEmail",
            title: "Создатель",
        },
        {
            key: "DateForRevision",
            title: "Пересмотр документа",
        }
    ]);

    const deleteFilter = (id: number) => {
        deleteItemRequest({
            listName: favoriteFiltersListName,
            ID: id
        }).then(() => {
            setReRenderFilterSettings(!reRenderFilterSettings);
        })
    };

    useEffect(() => {
        setLoading(true);
        if (Object.keys(currentUser).length > 0 && currentUser.id > 0) {
            getItemsRequest({ listName: favoriteFiltersListName, filters: { Author: currentUser.id, Type: type } }).then(results => {
                setFavoriteFilters([...results.items]);
                setLoading(false);
            });
        }
    }, [reRenderFilterSettings, currentUser]);

    useEffect(() => {
        if (Object.keys(checkedFilter).length > 0) {
            setFiltersParams(checkedFilter.filter.MDFullFilters && JSON.parse(checkedFilter.filter.MDFullFilters) || {});
            setUserFilterCheck && setUserFilterCheck(true);
            if (userFilterCheck) {
                setReRenderUserFilter && setReRenderUserFilter(Math.random());
            }
            reRenderTableFlag(false);
        }
        setOpen(false);
    }, [checkedFilter]);

    const updateDefaultFilterHandle = (props: any) => {
        setLoading(true);
        const { id, defaultValue, filter } = props;
        let updateFilters: any = [];
        favoriteFilters.forEach((filter: any) => {
            updateFilters = [...updateFilters, {
                ID: filter.ID,
                DefaultFilter: false
            }]
        });
        updateItemRequest({ listName: favoriteFiltersListName, body: updateFilters[0], bodyArr: updateFilters }).then(() => {
            updateItemRequest({ listName: favoriteFiltersListName, body: { ID: id, DefaultFilter: defaultValue } }).then(() => {
                let tempFilters = [...favoriteFilters];
                let updateFilters = tempFilters.map(filter => {
                    return { ...filter, DefaultFilter: filter.ID === id && defaultValue || false }
                });
                setFavoriteFilters([...updateFilters]);
                setLoading(false);
            });
        });
    }

    useEffect(() => {
        if (favoriteFilters.length > 0) {
            const fitersDefault = favoriteFilters.filter((filter: any) => filter.DefaultFilter);
            if (fitersDefault.length > 0) {
                const filterDefault = fitersDefault[0];
                setDefaultUserFilter(filterDefault);
                setCheckedFilter({ id: filterDefault.ID, filter: filterDefault });
            } else {
                setUserFilterCheck && setUserFilterCheck(true);
            }
        } else if (favoriteFilters.length === 0 && !loading) {
            setUserFilterCheck && setUserFilterCheck(true);
        }
    }, [favoriteFilters]);

    return (
        <>
            {loading &&
                <FlexCol className="flex w-6 h-6">
                    <Loading />
                </FlexCol> ||
                <>
                    {favoriteFilters.length > 0 &&
                        <div>
                            {!open ? (
                                <svg className="cursor-pointer hover:text-darkblue" width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setOpen(!open)}>
                                    <path
                                        d="M1.62106 1.55277L1.62103 1.5528L1.62526 1.55693L9.65026 9.39443L10.0013 9.73724L10.3507 9.39276L18.3757 1.48027L18.3782 1.47777C18.5204 1.33553 18.7288 1.33553 18.8711 1.47777C19.0129 1.61959 19.0133 1.8272 18.8723 1.9694C18.8719 1.96982 18.8715 1.97025 18.8711 1.97067L10.2492 10.4426L10.2492 10.4426L10.2461 10.4457C10.1016 10.5901 10.0343 10.5992 9.99961 10.5992C9.91122 10.5992 9.83465 10.5776 9.72998 10.4979L1.12692 2.04442C0.985926 1.90221 0.986341 1.69459 1.12816 1.55277C1.2704 1.41053 1.47882 1.41053 1.62106 1.55277Z"
                                        fill="currentColor"
                                        strokeWidth="1.5"
                                    />
                                </svg>
                            ) : (
                                <div className="relative">
                                    <svg className="cursor-pointer" width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setOpen(!open)}>
                                        <path
                                            d="M10.3507 2.60724L10.0004 2.26193L9.64941 2.60641L1.62441 10.4814L1.62439 10.4814L1.62106 10.4847C1.47882 10.627 1.2704 10.627 1.12816 10.4847C0.986342 10.3429 0.985926 10.1353 1.12692 9.99309L9.75005 1.51992L9.75006 1.51994L9.75316 1.51683C9.8954 1.3746 10.1038 1.3746 10.2461 1.51683L10.246 1.51685L10.2492 1.51992L18.8711 9.99183C18.8715 9.99226 18.8719 9.99268 18.8723 9.9931C19.0133 10.1353 19.0129 10.3429 18.8711 10.4847C18.7968 10.559 18.6935 10.6008 18.6246 10.6008C18.5363 10.6008 18.4598 10.5792 18.3553 10.4997L10.3507 2.60724Z"
                                            fill="#9CA3AF"
                                            stroke="#012169"
                                        />
                                    </svg>
                                    <div className="absolute top-5 right-0 z-[50] w-[600px]">
                                        {favoriteFilters.map((filter: any) => (
                                            <div className="flex flex-col gap-5 bg-[#ffffff] p-5 rounded-lg shadow-md mb-[10px] hover:bg-[#F3F4F6]" key={filter.ID}>
                                                <div className="flex justify-between">
                                                    <div className="flex gap-[8px]">
                                                        <button onClick={() => {
                                                            setCheckedFilter(checkedFilter.id !== filter.ID && { id: filter.ID, filter } || {});
                                                        }} className="hover:cursor-pointer">
                                                            <CustomRadio checked={filtersParams === filter.MDFullFilters} />
                                                        </button>
                                                        <span className="text-[#111928]">{filter.Title}</span>
                                                    </div>
                                                    <button className="hover:cursor-pointer" onClick={() => deleteFilter(filter.ID)}>
                                                        <Trash />
                                                    </button>
                                                </div>
                                                <ul className="flex flex-col w-full gap-2">
                                                    {Object.keys(JSON.parse(filter.DisplayFilters)).map((key: string) => (
                                                        <li className="w-full">
                                                            <span className="text-[#637381]">{fieldsFilter.filter((field: any) => field.key === key).length > 0 && fieldsFilter.filter((field: any) => field.key === key)[0]['title'] || key}: </span><span className="text-[#111928]">{Array.isArray(JSON.parse(filter.DisplayFilters)[key]) && JSON.parse(filter.DisplayFilters)[key].some((item: any) => item.name) && JSON.parse(filter.DisplayFilters)[key].map((item: any) => item.name).join(", ") || Array.isArray(JSON.parse(filter.DisplayFilters)[key]) && JSON.parse(filter.DisplayFilters)[key].join(', ') || JSON.parse(filter.DisplayFilters)[key]}</span>
                                                        </li>
                                                    ))}
                                                    <li className="w-full">
                                                        <div className="flex gap-[8px]">
                                                            <button onClick={() => updateDefaultFilterHandle({ id: filter.ID, defaultValue: !filter.DefaultFilter, filter })} className="hover:cursor-pointer">
                                                                <CustomRadio checked={filter.DefaultFilter} />
                                                            </button>
                                                            <span className="text-[#111928]">Установить по умолчанию</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </>
            }
        </>
    );
};
